import * as Apollo from '@apollo/client';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ApolloUtil {
  type QueryFunc<TData, TVariables extends Apollo.OperationVariables> = (
    ...baseOptions: never
  ) => Apollo.QueryResult<TData, TVariables>;

  type QueryResultElements<TData, TVariables extends Apollo.OperationVariables> = TData &
    Pick<Apollo.QueryResult<TData, TVariables>, 'refetch' | 'loading'> & { ___queryResult: '___QueryResult' }; // eslint-disable-line @typescript-eslint/naming-convention

  export type QueryResult<TFunc> =
    TFunc extends QueryFunc<infer TData, infer TVariables> ? QueryResultElements<TData, TVariables> : never;

  export function toQueryResult<TData, TVariables extends Apollo.OperationVariables>(
    queryResult: Apollo.QueryResult<TData, TVariables>,
  ): QueryResultElements<TData, TVariables> {
    return {
      ...queryResult.data!,
      refetch: queryResult.refetch,
      loading: queryResult.loading,
      ___queryResult: '___QueryResult',
    };
  }
}
